import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type {
    ItemPartContentProps,
    IItemHeaderProps
} from "../../type";
import {
    withItemContext
} from "../../context";
import stylesheet from "../../stylesheet";

const ItemHeaderBase: FC<ItemPartContentProps<IItemHeaderProps>> = ({
    children,
    context,
    style,
    ...props
}) => {
    return <View
        {...props}
        style={[
            style,
            stylesheet.strip,
            context.isPressable ? stylesheet.passThrough : undefined
        ]}
    >
        {children}
    </View>;
};
export default withItemContext("header", ItemHeaderBase);
